import React, { Component } from 'react';
import BrowseFiles from '../../files/BrowseFiles';
import { Button } from 'react-bootstrap';
import FileCell from './FileCell';

const style = {
  padding: '15px 20px',
  backgroundColor: '#cccccc24'
};

class AssetFileInput extends Component {
  constructor(props) {
    super(props);
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
    this.state = { isOpen: false };
  }
  toggleIsOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }
  render() {
    const { isOpen } = this.state;
    const { field, input, label } = this.props;
    const { opts } = field || {};

    const handleAddFile = value => {
      const { file } = value || {};
      input.onChange(file.filename);
      this.setState({ isOpen: false });
    };

    const { value } = input || {};

    return (
      <div className="fileinput">
        <div>
          <div><label className="control-label">{label}</label></div>
          <Button
            type="button"
            bsStyle="hollow-info"
            bsSize="sm"
            onClick={this.toggleIsOpen}
          >
            Choose File
          </Button>
          <FileCell value={value} />

        </div>
        {/* TODO animate */}
        {isOpen &&
          <div style={style}>
            <BrowseFiles isBrowsing handleAddFile={handleAddFile} />
          </div>}

      </div>
    );
  }
}

export default AssetFileInput;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/AssetFileInput.js